<template>
    <div class="gap__text--wrapper" :class="'gap__text--wrapper-'+index">
        <div class="gap__text">
            <slot name="text"></slot>
        </div>
        <div class="gap__text--overlay" :class="'gap__text--overlay--'+(index + 1)" v-for="(answer,index) in answers">
            <template v-for="answeritem in answer">
                <div v-bind:data-value="answeritem.value" v-if="answeritem.value == true" v-on:click="selectAnswer(index, answeritem.text, answeritem.value)">{{answeritem.text}}</div>
                <div data-value="false" v-on:click="selectAnswer(index, answeritem.text, answeritem.value)" v-else>{{answeritem.text}}</div>
            </template>

        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: "GapText",
        props:{
            answers: Array,
            index: Number
        },
        mounted(){
            console.log("mounted", this.answers);
            let _this = this;
            let gapNumber = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').length;

            if(gapNumber == 0){
                while(gapNumber == 0){
                    let gapNumber = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').length;
                    if(this.answers.length != gapNumber){
                        throw new Error('Missmatch between gaps and answers at Question: ' + _this.index + " Answers: " + _this.answers.length + " Gaps: " + gapNumber);
                    }
                    let gaps = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span');

                    $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').each(function (index) {
                        let ind = index -1;
                        $(this).attr('data-gap', '.gap__text--overlay--'+(index+1));

                        let a = _this.answers[index];
                        let rightText =  "";
                        for(let i = 0; i < a.length; i++){

                            let val =  _this.answers[index][i].value;
                            if(val == true){
                                rightText = _this.answers[index][i].text;
                            }
                        }
                        for (let i = 0; i < rightText.length; i++) {
                            $(this).append('<div class="underscore"></div>')
                        }
                        //$(this).html(rightText);
                    })
                    $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').on('click', function () {
                        let overlay = $(this).data('gap');
                        $('.gap__text--wrapper-'+ _this.index).find(overlay).addClass('show');
                    })
                }

            } else {
                if(this.answers.length != gapNumber){
                    throw new Error('Missmatch between gaps and answers at Question: ' + _this.index + " Answers: " + _this.answers.length + " Gaps: " + gapNumber);
                }
                let gaps = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span');

                $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').each(function (index) {
                    let ind = index -1;
                    $(this).attr('data-gap', '.gap__text--overlay--'+(index+1));

                    let a = _this.answers[index];
                    let rightText =  "";
                    for(let i = 0; i < a.length; i++){

                        let val =  _this.answers[index][i].value;
                        if(val == true){
                            rightText = _this.answers[index][i].text;
                        }
                    }
                    for (let i = 0; i < rightText.length; i++) {
                        $(this).append('<div class="underscore"></div>')
                    }
                    //$(this).html(rightText);
                })
                $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').on('click', function () {
                    let overlay = $(this).data('gap');
                    $('.gap__text--wrapper-'+ _this.index).find(overlay).addClass('show');
                })
            }

        },
        methods:{
            selectAnswer(index, text, value){
                let _this = this;

                let gaps = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span');
                $(gaps[index]).html(text);
                $(gaps[index]).addClass('selected');
                if(value == false){
                    $(gaps[index]).removeClass('right');
                    $(gaps[index]).addClass('wrong');
                } else {
                    $(gaps[index]).removeClass('wrong');
                    $(gaps[index]).addClass('right');
                }

                $('.gap__text--overlay').removeClass('show');
            }
        },
        created() {
                this.$store.watch(
                    (state, getters) => getters.lang,
                    (newValue, oldValue) => {
                        console.log("changed", this.answers);
                    }
                )
        },
        watch: {
            answers: {
                handler(val){
                    let _this = this;
                    console.log($('.gap__text--wrapper-'+ _this.index + ' .gap__text'), _this.index);
                    let gapNumber = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').length;
                    if(this.answers.length != gapNumber){
                        throw new Error('Missmatch between gaps and answers at Question: ' + _this.index + " Answers: " + _this.answers.length + " Gaps: " + gapNumber);
                    }
                    let gaps = $('.gap__text--wrapper-'+ _this.index + ' .gap__text span');

                    $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').each(function (index) {
                        let ind = index -1;
                        $(this).attr('data-gap', '.gap__text--overlay--'+(index+1));

                        let a = _this.answers[index];
                        let rightText =  "";
                        for(let i = 0; i < a.length; i++){

                            let val =  _this.answers[index][i].value;
                            if(val == true){
                                rightText = _this.answers[index][i].text;
                            }
                        }
                        for (let i = 0; i < rightText.length; i++) {
                            $(this).append('<div class="underscore"></div>')
                        }
                        //$(this).html(rightText);
                    })
                    $('.gap__text--wrapper-'+ _this.index + ' .gap__text span').on('click', function () {
                        let overlay = $(this).data('gap');
                        $('.gap__text--wrapper-'+ _this.index).find(overlay).addClass('show');
                    })
                },
                deep: true
            }
        }
    }
</script>

<style scoped lang="scss">

    .gap__text{
        span{

        }
    }

</style>